import React,{Component} from 'react';
import Flexbox from '../components/misc/Flexbox'; 

class Unterstutzer extends Component {
	
	render(){				
		const { title_left:left,title_right:right,gallery_image:logos } = this.props;
		return(
				<div className="container-fluid lg-side-padding margin-top-50">
					<div className="row">
						<div className="col-md-12">
							<Flexbox left={left} right={right} />
							
							<div className="logo-list clearfix">
							{
								logos.map( (data,i)=> {
									return <div className="logo-item" key={i}><a aria-label={data.title} title={data.title} alt={data.alt} style={{backgroundImage: 'url('+data.image+')'}}>&nbsp;</a></div>
								})
							}
							</div>
						</div>
					</div>
				</div>
		)
	}
}
export default Unterstutzer;




// WEBPACK FOOTER //
// ./src/components/Unterstutzer.js